import { useCookies } from "lib/cookie-monster";
import { useState } from "react";
import styled from "styled-components";
import PadlockOpen from "svg/padlock-open.svg";
import PadlockClosed from "svg/padlock-closed.svg";

const Container = styled.div`
    width: 100%;
    background: repeating-linear-gradient(
        -30deg,
        #8b0000,
        #8b0000 10px,
        #960000 10px,
        #960000 20px
    );
    color: white;
    text-align: center;
    padding: 12px;
    font-weight: bold;
    text-transform: uppercase;
    line-height: 32px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    margin-top: 50px;
`;

const Button = styled.button`
    background: none;
    border: none;
    padding: 0;
    margin: 1px 0 0 8px;
    color: ${({ persistentPreview }) => (persistentPreview ? "forestgreen" : "white")};
    float: right;
    cursor: pointer;

    svg {
        width: 25px;
        height: 25px;
    }
`;

export const PreviewNote = () => {
    const { cookies, setCookie, removeCookie } = useCookies();
    const [isPreviewMode, setIsPreviewMode] = useState(cookies.previewMode === "enabled");
    const togglePreviewModeCookie = () => {
        if (isPreviewMode) {
            removeCookie("previewMode");
            setIsPreviewMode(false);
            return;
        }
        setCookie("previewMode", "enabled");
        setIsPreviewMode(true);
    };
    return (
        <Container>
            NOTE: This is a preview & not representative of publicly available content.
            <Button persistentPreview={isPreviewMode} onClick={togglePreviewModeCookie}>
                {isPreviewMode ? <PadlockClosed /> : <PadlockOpen />}
            </Button>
        </Container>
    );
};
